import { render, staticRenderFns } from "./look-up-attribute.vue?vue&type=template&id=bfa54a48&scoped=true"
import script from "./look-up-attribute.vue?vue&type=script&lang=js"
export * from "./look-up-attribute.vue?vue&type=script&lang=js"
import style0 from "./look-up-attribute.vue?vue&type=style&index=0&id=bfa54a48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa54a48",
  null
  
)

export default component.exports